import { axios_public } from "../../../axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { CircularProgress } from "@mui/material";

const TenantCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get("access_token");
    const idToken = params.get("id_token");

    if (accessToken) {
      axios_public
        .post("/tenantAPI/user/login", { accessToken, idToken })
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("tenant_username", res.data.fname + " " + res.data.lname);

            localStorage.setItem("TENANT_NAME", res.data.tenantName);
            localStorage.setItem("TENANT_USER_ID", res.data.id);
            localStorage.setItem("TENANT_USER_MAIL", res.data.mail);
            localStorage.setItem("TREXO_TENANT_AUTH_TOKEN", res.data.token);
            localStorage.setItem("TENANT_ROLE", res.data.role);
            localStorage.setItem("ICON", res.data.icon);
            const sessionId = uuidv4();
            sessionStorage.setItem("sessionId", sessionId);

            const latestPath = localStorage.getItem("latestPath");
            if (latestPath?.includes("collaboration-space") || latestPath?.includes("/oa/")) {
              navigate(latestPath);
            } else {
              navigate("/dashboard");
            }
          }
        })
        .catch((error) => {
          setTimeout(() => navigate("/login"), 2000);
        });
    } else {
      setTimeout(() => navigate("/login"), 2000);
    }
  }, [navigate]);
  return (
    <div>
      <CircularProgress />
      <p>Logging you in...</p>
    </div>
  );
};

export default TenantCallback;